<template>
  <footer class="game-footer">
  </footer>
</template>

<script>
export default {
  name: 'GameFooter'
}
</script>

<style scoped>
.game-footer {
  background-color: var(--dark-slate-gray);
  color: white;
  padding: 15px;
  text-align: center;
  z-index: 50;
  border-top: 2px solid var(--game-accent, var(--cyber-yellow));
}
</style>